"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "adlm": 8492,
    "afak": 8493,
    "aghb": 8494,
    "ahom": 8495,
    "arab": 8496,
    "aran": 8497,
    "armi": 8498,
    "armn": 8499,
    "avst": 8500,
    "bali": 8501,
    "bamu": 8502,
    "bass": 8503,
    "batk": 8504,
    "beng": 8505,
    "bhks": 8506,
    "blis": 8507,
    "bopo": 8508,
    "brah": 8509,
    "brai": 8510,
    "bugi": 8511,
    "buhd": 8512,
    "cakm": 8513,
    "cans": 8514,
    "cari": 8515,
    "cham": 8516,
    "cher": 8517,
    "chrs": 8518,
    "cirt": 8519,
    "copt": 8520,
    "cpmn": 8521,
    "cprt": 8522,
    "cyrl": 8523,
    "cyrs": 8524,
    "deva": 8525,
    "diak": 8526,
    "dogr": 8527,
    "dsrt": 8528,
    "dupl": 8529,
    "egyd": 8530,
    "egyh": 8531,
    "egyp": 8532,
    "elba": 8533,
    "elym": 8534,
    "ethi": 8535,
    "geok": 8536,
    "geor": 8537,
    "glag": 8538,
    "gong": 8539,
    "gonm": 8540,
    "goth": 8541,
    "gran": 8542,
    "grek": 8543,
    "gujr": 8544,
    "guru": 8545,
    "hanb": 8546,
    "hang": 8547,
    "hani": 8548,
    "hano": 8549,
    "hans": 8550,
    "hant": 8551,
    "hatr": 8552,
    "hebr": 8553,
    "hira": 8554,
    "hluw": 8555,
    "hmng": 8556,
    "hmnp": 8557,
    "hrkt": 8558,
    "hung": 8559,
    "inds": 8560,
    "ital": 8561,
    "jamo": 8562,
    "java": 8563,
    "jpan": 8564,
    "jurc": 8565,
    "kali": 8566,
    "kana": 8567,
    "kawi": 8568,
    "khar": 8569,
    "khmr": 8570,
    "khoj": 8571,
    "kitl": 8572,
    "kits": 8573,
    "knda": 8574,
    "kore": 8575,
    "kpel": 8576,
    "kthi": 8577,
    "lana": 8578,
    "laoo": 8579,
    "latf": 8580,
    "latg": 8581,
    "latn": 8582,
    "leke": 8583,
    "lepc": 8584,
    "limb": 8585,
    "lina": 8586,
    "linb": 8587,
    "lisu": 8588,
    "loma": 8589,
    "lyci": 8590,
    "lydi": 8591,
    "mahj": 8592,
    "maka": 8593,
    "mand": 8594,
    "mani": 8595,
    "marc": 8596,
    "maya": 8597,
    "medf": 8598,
    "mend": 8599,
    "merc": 8600,
    "mero": 8601,
    "mlym": 8602,
    "modi": 8603,
    "mong": 8604,
    "moon": 8605,
    "mroo": 8606,
    "mtei": 8607,
    "mult": 8608,
    "mymr": 8609,
    "nagm": 8610,
    "nand": 8611,
    "narb": 8612,
    "nbat": 8613,
    "newa": 8614,
    "nkdb": 8615,
    "nkgb": 8616,
    "nkoo": 8617,
    "nshu": 8618,
    "ogam": 8619,
    "olck": 8620,
    "orkh": 8621,
    "orya": 8622,
    "osge": 8623,
    "osma": 8624,
    "ougr": 8625,
    "palm": 8626,
    "pauc": 8627,
    "pcun": 8628,
    "pelm": 8629,
    "perm": 8630,
    "phag": 8631,
    "phli": 8632,
    "phlp": 8633,
    "phlv": 8634,
    "phnx": 8635,
    "piqd": 8636,
    "plrd": 8637,
    "prti": 8638,
    "psin": 8639,
    "qaaa..qabx": 8640,
    "ranj": 8641,
    "rjng": 8642,
    "rohg": 8643,
    "roro": 8644,
    "runr": 8645,
    "samr": 8646,
    "sara": 8647,
    "sarb": 8648,
    "saur": 8649,
    "sgnw": 8650,
    "shaw": 8651,
    "shrd": 8652,
    "shui": 8653,
    "sidd": 8654,
    "sind": 8655,
    "sinh": 8656,
    "sogd": 8657,
    "sogo": 8658,
    "sora": 8659,
    "soyo": 8660,
    "sund": 8661,
    "sunu": 8662,
    "sylo": 8663,
    "syrc": 8664,
    "syre": 8665,
    "syrj": 8666,
    "syrn": 8667,
    "tagb": 8668,
    "takr": 8669,
    "tale": 8670,
    "talu": 8671,
    "taml": 8672,
    "tang": 8673,
    "tavt": 8674,
    "telu": 8675,
    "teng": 8676,
    "tfng": 8677,
    "tglg": 8678,
    "thaa": 8679,
    "thai": 8680,
    "tibt": 8681,
    "tirh": 8682,
    "tnsa": 8683,
    "toto": 8684,
    "ugar": 8685,
    "vaii": 8686,
    "visp": 8687,
    "vith": 8688,
    "wara": 8689,
    "wcho": 8690,
    "wole": 8691,
    "xpeo": 8692,
    "xsux": 8693,
    "yezi": 8694,
    "yiii": 8695,
    "zanb": 8696,
    "zinh": 8697,
    "zmth": 8698,
    "zsye": 8699,
    "zsym": 8700,
    "zxxx": 8701,
    "zyyy": 8702,
    "zzzz": 8703
};
//# sourceMappingURL=script.json.js.map